import colors from 'vuetify/lib/util/colors';

const themeColors = {
	light: "#fdf9ff",
	dark: "#1e0146",
	purple: "#4b1590",
	darkestPurple: "#1e0146",
	teal: "#33BBCC",
	magenta: "#E524C5",
	green: "#28df87"
};


export default {
	options: {
		customProperties: true,
	},

	primary: themeColors.teal,
	secondary: themeColors.purple,
	tertiary: '#c643c8',
	accent: colors.deepPurple.lighten2,

	magenta: themeColors.magenta,
	error: themeColors.magenta,

	anchor: themeColors.light,

	odd: "#260159",
	background: themeColors.darkestPurple,

	// departments
	admin: "#4C1396",
	it: "#0097a7",
	video: "#283593",
	designer: "#6e48d0",
	developer: "#3673ce",

	// status
	pending: "#1e0146",
	overdue: themeColors.magenta,
	today: "#B7159C",
	soon: "#800F6D",
	later: "#49093E",

	current: colors.lightBlue.darken1,

	//timer
	"status-active": themeColors.green,
	disabled: colors.grey.darken4,

	"task-complete": colors.teal.base,
	"task-current": "#c643c8",
	"task-pending": colors.deepPurple.base,

	// task status:
	unassigned: themeColors.magenta,
	assigned: themeColors.purple,
	completed: colors.teal.base,

	overtime: themeColors.magenta,

	deadline: themeColors.magenta,
	reminder: colors.blue.darken2,

	"text-color": themeColors.light,
	"cards": themeColors.darkestPurple,
	"app-bar": themeColors.darkestPurple,
	"toolbar": "#120030",
	"chips": themeColors.purple,
	"dividers": themeColors.purple,
	"navigation-drawer": themeColors.darkestPurple,
	"system-bar": themeColors.purple,

	// calendar
	"calendar-background": themeColors.purple,
	"outside-background-color": themeColors.darkestPurple,
	"weeknumber-background-color": themeColors.darkestPurple,
	"line-color": themeColors.darkestPurple,
	"interval-color": themeColors.darkestPurple,
	"interval-line-color": themeColors.darkestPurple,
	"past-color": themeColors.light,
	
	// table
	"table-active": themeColors.purple,
	"table-hover": themeColors.purple,
	"table-group": "#260159",
	
	// picker
	"picker-body": themeColors.purple,
	"picker-clock": themeColors.purple,
	"picker-indeterminateTime": themeColors.purple,
	"picker-title": themeColors.purple,
	
	// kbd
	"kbd-bg": themeColors.magenta,
	"kbd-color": themeColors.light,

	"toggle": themeColors.magenta,

	// text over background
	"text-over-bg": colors.grey.lighten1,
	"ot-text-over-bg": "#ff4ce1",
	"working-text-over-bg": themeColors.green
}